import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-seven-dual",
  templateUrl: "./axle-seven-dual.component.html",
  styleUrls: ["./axle-seven-dual.component.scss"],
})
export class AxleSevenDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorSevenIntLeftSelect: any = [];
  public sensorSevenIntRightSelect: any = [];

  public sensorSevenExtLeftSelect: any = [];
  public sensorSevenExtRightSelect: any = [];

  public sensorSevenIntRightCombo: any = [];
  public sensorSevenIntLeftCombo: any = [];

  public sensorSevenExtRightCombo: any = [];
  public sensorSevenExtLeftCombo: any = [];

  public axisSevenDoubleLeftIntForm: FormGroup;
  public axisSevenDoubleLeftExtForm: FormGroup;
  public axisSevenDoubleRightIntForm: FormGroup;
  public axisSevenDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorSevenExtRightCombo = [];
      this.sensorSevenExtLeftCombo = [];
      this.sensorSevenIntRightCombo = [];
      this.sensorSevenIntLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorSevenExtRightCombo.push(element);
          this.sensorSevenExtLeftCombo.push(element);
          this.sensorSevenIntRightCombo.push(element);
          this.sensorSevenIntLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisSevenDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSevenDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSevenDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSevenDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorSevenExtRightCombo.push(element);
        this.sensorSevenExtLeftCombo.push(element);
        this.sensorSevenIntRightCombo.push(element);
        this.sensorSevenIntLeftCombo.push(element);
      });
    }
    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisSevenDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 7 ESQ INT"
      );
      this.axisSevenDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 7 ESQ EXT"
      );

      this.axisSevenDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 7 DIR INT"
      );
      this.axisSevenDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 7 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo7DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          16
        );
        const eixo7EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          15
        );
        const eixo7DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          32
        );
        const eixo7EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          31
        );

        // EIXO 7 DIREITO EXTERNO
        if (eixo7DireitoExt != null) {
          this.axisSevenDoubleRightExtForm.controls["id"].setValue(
            eixo7DireitoExt.id
          );

          if (eixo7DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorSevenExtRightCombo, eixo7DireitoExt.sensor);
            this.sensorSevenExtRightSelect = eixo7DireitoExt.sensor.id;
          }

          if (eixo7DireitoExt.pneu != null) {
            this.axisSevenDoubleRightExtForm.controls["pneu"].setValue(
              eixo7DireitoExt.pneu.numeroFogo
            );
          }

          this.axisSevenDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo7DireitoExt.nrPressaoMinima
          );

          this.axisSevenDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo7DireitoExt.nrPressaoMaxima
          );

          this.axisSevenDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo7DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 7 ESQUERDO EXTERNO
        if (eixo7EsquerdoExt != null) {
          this.axisSevenDoubleLeftExtForm.controls["id"].setValue(
            eixo7EsquerdoExt.id
          );

          if (eixo7EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorSevenExtLeftCombo, eixo7EsquerdoExt.sensor);
            this.sensorSevenExtLeftSelect = eixo7EsquerdoExt.sensor.id;
          }

          if (eixo7EsquerdoExt.pneu != null) {
            this.axisSevenDoubleLeftExtForm.controls["pneu"].setValue(
              eixo7EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisSevenDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo7EsquerdoExt.nrPressaoMinima
          );

          this.axisSevenDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo7EsquerdoExt.nrPressaoMaxima
          );

          this.axisSevenDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo7EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 7 DIREITO INTERNO
        if (eixo7DireitoInt != null) {
          this.axisSevenDoubleRightIntForm.controls["id"].setValue(
            eixo7DireitoInt.id
          );

          if (eixo7DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorSevenIntRightCombo, eixo7DireitoInt.sensor);
            this.sensorSevenIntRightSelect = eixo7DireitoInt.sensor.id;
          }

          if (eixo7DireitoInt.pneu != null) {
            this.axisSevenDoubleRightIntForm.controls["pneu"].setValue(
              eixo7DireitoInt.pneu.numeroFogo
            );
          }

          this.axisSevenDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo7DireitoInt.nrPressaoMinima
          );

          this.axisSevenDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo7DireitoInt.nrPressaoMaxima
          );

          this.axisSevenDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo7DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 7 ESQUERDO INTERNO
        if (eixo7EsquerdoInt != null) {
          this.axisSevenDoubleLeftIntForm.controls["id"].setValue(
            eixo7EsquerdoInt.id
          );

          if (eixo7EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorSevenIntLeftCombo, eixo7EsquerdoInt.sensor);
            this.sensorSevenIntLeftSelect = eixo7EsquerdoInt.sensor.id;
          }

          if (eixo7EsquerdoInt.pneu != null) {
            this.axisSevenDoubleLeftIntForm.controls["pneu"].setValue(
              eixo7EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisSevenDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo7EsquerdoInt.nrPressaoMinima
          );

          this.axisSevenDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo7EsquerdoInt.nrPressaoMaxima
          );

          this.axisSevenDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo7EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisSevenDoubleLeftExtForm.value);
      estepeArray.push(this.axisSevenDoubleLeftIntForm.value);
      estepeArray.push(this.axisSevenDoubleRightExtForm.value);
      estepeArray.push(this.axisSevenDoubleRightIntForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisSevenDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisSevenDoubleLeftExtForm.get("id").setValue("");
      this.axisSevenDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisSevenDoubleLeftIntForm.get("id").setValue("");
      this.axisSevenDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisSevenDoubleRightExtForm.get("id").setValue("");
      this.axisSevenDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisSevenDoubleRightIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisSevenDoubleLeftExtForm.value);
      estepeArray.push(this.axisSevenDoubleLeftIntForm.value);
      estepeArray.push(this.axisSevenDoubleRightExtForm.value);
      estepeArray.push(this.axisSevenDoubleRightIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 7 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 7 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
